import {
  updateLastGetNewProductError,
  updateLastGetNewProductSuccess,
} from '@redux/branding/actions';
import { useMutation } from '@tanstack/react-query';
import { useQueryBrandingNavigation } from 'hooks';
import { useDispatch } from 'react-redux';
import { updateGetNewProduct } from 'services/preload';

export const useUpdateNewProduct = () => {
  const dispatch = useDispatch();
  const { invalidateBrandingNavigation } = useQueryBrandingNavigation();

  return useMutation({
    mutationFn: updateGetNewProduct,
    onSuccess: (response) => {
      if (response?.isSuccess) {
        dispatch(updateLastGetNewProductSuccess());
        invalidateBrandingNavigation();
      } else {
        dispatch(updateLastGetNewProductError(response.message));
      }
    },
    onError: () => {
      dispatch(updateLastGetNewProductError('Server Error'));
    },
  });
};
